import globalIP from '@/GlobelIP';
import ugr from '@/UGRoute';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Container,
    Button,
    Form,
    FlexboxGrid,
    Col,
    InputPicker,
    Checkbox,
    RadioGroup,
    Radio,
    useToaster,
    Message,
} from 'rsuite';
const data = [
    'L',
    'LCL',
    'MRP',
    'Cost',
    'Price',
].map(item => ({ label: item, value: item }));
const data2 = [
    'M',
    'FCL',
].map(item => ({ label: item, value: item }));
const data3 = [
    'MX',
].map(item => ({ label: item, value: item }));
const Setting = () => {
    const ip = globalIP;
    const [value1, setValue1] = useState<string>("Non-Editable");
    const [value2, setValue2] = useState<string>("Non-Editable");
    const [value3, setValue3] = useState<string>("Non-Editable");
    const [value4, setValue4] = useState<string>("Non-Editable");
    const [value5, setValue5] = useState<string>("Non-Editable");
    const [isPriceChecked, setPriceChecked] = useState(false);
    const [isMaterialChecked, setMaterialChecked] = useState(false);
    const [isSizeChecked, setSizeChecked] = useState(false);
    const [isColourChecked, setColourChecked] = useState(false);
    const [isFinishChecked, setFinishChecked] = useState(false);
    const [isNetwtChecked, setNetwtChecked] = useState(false);
    const [isCBMChecked, setCBMChecked] = useState(false);
    const [isMOQChecked, setMOQChecked] = useState(false);
    const [isUSDCurrChecked, setUSDCurrChecked] = useState(false);
    const [isGBPCurrChecked, setGBPCurrChecked] = useState(false);
    const [isEUROCurrChecked, setEUROCurrChecked] = useState(false);
    const [isINRCurrChecked, setINRCurrChecked] = useState(false);
    const [companydata, setComoanyData] = useState([]);
    const [empnamedata, setempnameData] = useState<any>([]);
    const [empname, setEmpnane] = useState('');
    const [empid, setEmpid] = useState(0);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await fetch(`${ip}/api/user-details?populate=*`);
        const json = await response.json();
        const processedData = json.data.map((item) => ({
            label: item.attributes.Full_Name,
            value: item.attributes.Full_Name,
        }));
        setComoanyData(processedData);
    };
    const [componydata, setCompanyData] = useState([]);
    const [componyid, setCompanyid] = useState([]);
    useEffect(() => {
        fetchCompanyData();
    }, []);
    const fetchCompanyData = async () => {
        const response = await fetch(`${ip}/api/company-details?populate=*`);
        const json = await response.json();
        const prdcdArray = json.data.map(item => item.id);
        setCompanyid(prdcdArray);
        setCompanyData(json.data);
    };


    useEffect(() => {
        if (empname) {
            fetchDataid();
        }
    }, [empname]);
    const fetchDataid = async () => {
        const response = await fetch(`${ip}/api/user-details?populate=*&filters[Full_Name][$eq]=${empname}`);
        const json = await response.json();
        setempnameData(json.data);
        const prdcdArray = json.data.map(item => item.id);
        setEmpid(prdcdArray);
    };

    const [empdatarray, setEmpdatarray] = useState([]);
    const [empidarray, setEmpidarray] = useState([]);

    useEffect(() => {
        fetchDatauseid();
    }, []);
    const fetchDatauseid = async () => {
        const response = await fetch(`${ip}/api/user-details?populate=*`);
        const json = await response.json();
        setEmpdatarray(json.data);
        const prdcdArray = json.data.map(item => item.id);
        setEmpidarray(prdcdArray);
    };

    const [useredit, setUserEdit] = useState({
        SizeSH: 'Hide',
        SizeEdit: '',
        NetWtSH: 'Hide',
        PriceSH: 'Hide',
        PriceEdit: '',
        FinishSH: 'Hide',
        FinishEdit: '',
        ColourSH: 'Hide',
        ColourEdit: '',
        MaterialSH: 'Hide',
        MaterialEdit: '',
        CbmSH: 'Hide',
        MoqSH: 'Hide',
    });
    const [compedit, setCompEdit] = useState({
        minlabelname: '',
        avglabelname: '',
        maxlabelname: '',
    });

    const [usereditarray, setUserEditarray] = useState({
        USDCurr: 'Hide',
        GBPCurr: 'Hide',
        EUROCurr: 'Hide',
        INRCurr: 'Hide',
    });
    useEffect(() => {
        if (empnamedata) {
            setDataid();
        }
        if (empdatarray) {


            setDatauser();
        }
    }, [empnamedata, empdatarray]);
    const setDataid = () => {

        if ('Editable' == empnamedata.map(item => item.attributes.PriceEdit)) {
            setValue1('Editable');
            setPriceChecked(true);
        } else {
            setPriceChecked(false);
            setValue1('Non-Editable');
        }
        if ("Show" == empnamedata.map(item => item.attributes.PriceSH)) {
            setPriceChecked(true);
        }
        else {
            setPriceChecked(false);
        }
        if ("Editable" == empnamedata.map(item => item.attributes.ColourEdit)) {
            setValue4('Editable');
            setColourChecked(true);
        } else {
            setColourChecked(false);
            setValue4('Non-Editable');
        }
        if ("Show" == empnamedata.map(item => item.attributes.ColourSH)) {
            setColourChecked(true);
        } else {
            setColourChecked(false);
        }
        if ("Editable" == empnamedata.map(item => item.attributes.SizeEdit)) {
            setValue3('Editable');
            setSizeChecked(true);
        } else {
            setSizeChecked(false);
            setValue3('Non-Editable');
        }
        if ("Show" == empnamedata.map(item => item.attributes.SizeSH)) {
            setSizeChecked(true);
        } else {
            setSizeChecked(false);
        }
        if ("Editable" == empnamedata.map(item => item.attributes.MaterialEdit)) {
            setValue2('Editable');
            setMaterialChecked(true);
        }
        else {
            setMaterialChecked(false);
            setValue2('Non-Editable');
        }
        if ("Show" == empnamedata.map(item => item.attributes.MaterialSH)) {
            setMaterialChecked(true);
        }
        else {
            setMaterialChecked(false);
        }
        if ("Editable" == empnamedata.map(item => item.attributes.FinishEdit)) {
            setValue5('Editable');
            setFinishChecked(true);
        }
        else {
            setFinishChecked(false);
            setValue5('Non-Editable');
        }
        if ("Show" == empnamedata.map(item => item.attributes.FinishSH)) {
            setFinishChecked(true);
        }
        else {
            setFinishChecked(false);
        }
        if ("Show" == empnamedata.map(item => item.attributes.NetWtSH)) {
            setNetwtChecked(true);
        }
        else {
            setNetwtChecked(false);
        }
        if ("Show" == empnamedata.map(item => item.attributes.MoqSH)) {
            setMOQChecked(true);
        }
        else {
            setMOQChecked(false);
        }
        if ("Show" == empnamedata.map(item => item.attributes.CbmSH)) {
            setCBMChecked(true);
        }
        else {
            setCBMChecked(false);
        }



    };
    const setDatauser = () => {
        if (empdatarray.length > 0) {
            const USDCurrValue = empdatarray[0].attributes.USDCurr;
            const GBPValue = empdatarray[0].attributes.GBPCurr;
            const EUROValue = empdatarray[0].attributes.EUROCurr;
            const INRValue = empdatarray[0].attributes.INRCurr;
            if (USDCurrValue === "Show") {
                setUSDCurrChecked(true);
            }
            if (GBPValue === "Show") {
                setGBPCurrChecked(true);
            }
            if (EUROValue === "Show") {
                setEUROCurrChecked(true);
            }
            if (INRValue === "Show") {
                setINRCurrChecked(true);
            }
            setUserEditarray(prevData => ({
                ...prevData,
                USDCurr: USDCurrValue,
                GBPCurr: GBPValue,
                EUROCurr: EUROValue,
                INRCurr: INRValue
            }));
        }

        if (componydata.length > 0) {
            const minlabelname = componydata[0].attributes.minlabelname;
            const avglabelname = componydata[0].attributes.avglabelname;
            const maxlabelname = componydata[0].attributes.maxlabelname;
            setCompEdit(prevData => ({
                ...prevData,
                minlabelname: minlabelname,
                avglabelname: avglabelname,
                maxlabelname: maxlabelname,
            }));
        }
    };
    const toaster = useToaster();
    const handleStatusChange = async () => {
        if (empname == '') {
            toaster.push(<Message showIcon type='error' >
                Select the Employee Name
            </Message>, { placement: 'topCenter' });
        }
        else {
            /// userPut
            const formData = new FormData();
            formData.append("data", JSON.stringify({
                ...companydata,
                SizeSH: useredit.SizeSH,
                SizeEdit: value3,
                NetWtSH: useredit.NetWtSH,
                PriceSH: useredit.PriceSH,
                PriceEdit: value1,
                FinishSH: useredit.FinishSH,
                FinishEdit: value5,
                ColourSH: useredit.ColourSH,
                ColourEdit: value4,
                MaterialSH: useredit.MaterialSH,
                MaterialEdit: value2,
                CbmSH: useredit.CbmSH,
                MoqSH: useredit.MoqSH,
            }));
            fetch(`${ip}/api/user-details/${empid}`, {
                method: 'PUT',
                body: formData,
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);

                })
                .catch((error) => {
                    console.error(error);
                    toaster.push(<Message showIcon type='error' >
                        Something went wrong please try again.
                    </Message>, { placement: 'topCenter' });
                });


            /// companyPut
            const formData1 = new FormData();
            formData1.append("data", JSON.stringify({
                ...componydata,
                minlabelname: compedit.minlabelname,
                avglabelname: compedit.avglabelname,
                maxlabelname: compedit.maxlabelname,
            }));
            for (const arrayput of componyid) {
                fetch(`${ip}/api/company-details/${arrayput}`, {
                    method: 'PUT',
                    body: formData1,
                })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
            /// USerPutArray
            const formData2 = new FormData();
            formData2.append("data", JSON.stringify({
                ...empdatarray,
                USDCurr: usereditarray.USDCurr,
                GBPCurr: usereditarray.GBPCurr,
                EUROCurr: usereditarray.EUROCurr,
                INRCurr: usereditarray.INRCurr,
            }));
            for (const arrayput of empidarray) {
                fetch(`${ip}/api/user-details/${arrayput}`, {
                    method: 'PUT',
                    body: formData2,
                })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
            toaster.push(<Message showIcon type='success' >
                Save Successfully.
            </Message>, { placement: 'topEnd' });
        }
    };
    const handleCheckboxChange = (checkboxName) => {
        switch (checkboxName) {
            case 'Price':
                setPriceChecked(!isPriceChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    PriceSH: 'Show',
                }));
                if (isPriceChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        PriceSH: 'Hide',
                    }));
                    setValue1('Non-Editable')
                }
                break;
            case 'Material':
                setMaterialChecked(!isMaterialChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    MaterialSH: 'Show',
                }));
                if (isMaterialChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        MaterialSH: 'Hide',
                    }));
                    setValue2('Non-Editable')
                }
                break;
            case 'Size':
                setSizeChecked(!isSizeChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    SizeSH: 'Show',
                }));
                if (isSizeChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        SizeSH: 'Hide',
                    }));
                    setValue3('Non-Editable')
                }
                break;
            case 'Colour':
                setColourChecked(!isColourChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    ColourSH: 'Show',
                }));
                if (isColourChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        ColourSH: 'Hide',
                    }));
                    setValue4('Non-Editable')
                }
                break;
            case 'Finish':
                setFinishChecked(!isFinishChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    FinishSH: 'Show',
                }));
                if (isFinishChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        FinishSH: 'Hide',
                    }));
                    setValue5('Non-Editable')
                }
                break;
            case 'NetWt':
                setNetwtChecked(!isNetwtChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    NetWtSH: 'Show',
                }));
                if (isNetwtChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        NetWtSH: 'Hide',
                    }));
                }
                break
            case 'CBM':
                setCBMChecked(!isCBMChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    CbmSH: 'Show',
                }));
                if (isCBMChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        CbmSH: 'Hide',
                    }));
                }
                break
            case 'MOQ':
                setMOQChecked(!isMOQChecked);
                setUserEdit(prevData => ({
                    ...prevData,
                    MoqSH: 'Show',
                }));
                if (isMOQChecked) {
                    setUserEdit(prevData => ({
                        ...prevData,
                        MoqSH: 'Hide',
                    }));
                }
                break
            case 'USD':
                setUSDCurrChecked(!isUSDCurrChecked);
                setUserEditarray(prevData => ({
                    ...prevData,
                    USDCurr: 'Show',
                }));
                if (isUSDCurrChecked) {
                    setUserEditarray(prevData => ({
                        ...prevData,
                        USDCurr: 'Hide',
                    }));
                }
                break
            case 'INR':
                setINRCurrChecked(!isINRCurrChecked);
                setUserEditarray(prevData => ({
                    ...prevData,
                    INRCurr: 'Show',
                }));
                if (isINRCurrChecked) {
                    setUserEditarray(prevData => ({
                        ...prevData,
                        INRCurr: 'Hide',
                    }));
                }
                break
            case 'EURO':
                setEUROCurrChecked(!isEUROCurrChecked);
                setUserEditarray(prevData => ({
                    ...prevData,
                    EUROCurr: 'Show',
                }));
                if (isEUROCurrChecked) {
                    setUserEditarray(prevData => ({
                        ...prevData,
                        EUROCurr: 'Hide',
                    }));
                }
                break
            case 'GBP':
                setGBPCurrChecked(!isGBPCurrChecked);
                setUserEditarray(prevData => ({
                    ...prevData,
                    GBPCurr: 'Show',
                }));
                if (isGBPCurrChecked) {
                    setUserEditarray(prevData => ({
                        ...prevData,
                        GBPCurr: 'Hide',
                    }));
                }
                break
            default:
                break;
        }
    };
    const handleInputChange = (inputName, event, index) => {
        let value;
        if (event && event.target) {
            // If event is not null and has a target property
            value = event.target.value;
        } else {
            // Handle cases where event is null or doesn't have a target property
            value = event;
        }
        const updatedValue = value === null ? "" : value;
        setCompEdit({ ...compedit, [inputName]: updatedValue });
    }

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Setting</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Setting</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        <FlexboxGrid justify="start">
                            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                <h6>Assign Action</h6>
                                <Stack direction='column' alignItems='flex-start'>
                                    <Form.ControlLabel>Employee</Form.ControlLabel>
                                    <InputPicker data={companydata} style={{ width: 224 }} value={empname} onChange={setEmpnane} />
                                </Stack>
                                <FlexboxGrid justify="space-around">
                                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                                        <Stack direction='column' alignItems='flex-start'>
                                            <Checkbox checked={isPriceChecked} onChange={() => handleCheckboxChange('Price')}> Price</Checkbox>
                                            <Checkbox checked={isMaterialChecked} onChange={() => handleCheckboxChange('Material')}> Material</Checkbox>
                                            <Checkbox checked={isSizeChecked} onChange={() => handleCheckboxChange('Size')}> Size</Checkbox>
                                            <Checkbox checked={isColourChecked} onChange={() => handleCheckboxChange('Colour')}> Colour</Checkbox>
                                            <Checkbox checked={isFinishChecked} onChange={() => handleCheckboxChange('Finish')}> Finish</Checkbox>
                                            <Checkbox checked={isNetwtChecked} onChange={() => handleCheckboxChange('NetWt')}> Net Wt.</Checkbox>
                                            <Checkbox checked={isMOQChecked} onChange={() => handleCheckboxChange('MOQ')}> MOQ</Checkbox>
                                            <Checkbox checked={isCBMChecked} onChange={() => handleCheckboxChange('CBM')}> CBM</Checkbox>
                                        </Stack>
                                    </FlexboxGrid.Item>
                                    <FlexboxGrid.Item as={Col} colspan={24} md={18}>
                                        <Stack direction='column' alignItems='flex-start'>
                                            <RadioGroup inline name="radio-name" value={value1} onChange={(value) => setValue1(value as string)}>
                                                <Radio value="Editable">Editable</Radio>
                                                <Radio value="Non-Editable">Non-Editable</Radio>
                                            </RadioGroup>
                                            <RadioGroup inline name="radio-name" value={value2} onChange={(value) => setValue2(value as string)}>
                                                <Radio value="Editable">Editable</Radio>
                                                <Radio value="Non-Editable">Non-Editable</Radio>
                                            </RadioGroup>
                                            <RadioGroup inline name="radio-name" value={value3} onChange={(value) => setValue3(value as string)}>
                                                <Radio value="Editable">Editable</Radio>
                                                <Radio value="Non-Editable">Non-Editable</Radio>
                                            </RadioGroup>
                                            <RadioGroup inline name="radio-name" value={value4} onChange={(value) => setValue4(value as string)}>
                                                <Radio value="Editable">Editable</Radio>
                                                <Radio value="Non-Editable">Non-Editable</Radio>
                                            </RadioGroup>
                                            <RadioGroup inline name="radio-name" value={value5} onChange={(value) => setValue5(value as string)}>
                                                <Radio value="Editable">Editable</Radio>
                                                <Radio value="Non-Editable">Non-Editable</Radio>
                                            </RadioGroup>
                                        </Stack>
                                    </FlexboxGrid.Item>
                                </FlexboxGrid>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                <h6>Currency</h6>
                                <FlexboxGrid justify="start">
                                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                                        <Checkbox checked={isUSDCurrChecked} readOnly onChange={() => handleCheckboxChange('USD')}> USD</Checkbox>
                                    </FlexboxGrid.Item>
                                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                                        <Checkbox checked={isINRCurrChecked} readOnly onChange={() => handleCheckboxChange('INR')}> INR</Checkbox>
                                    </FlexboxGrid.Item>
                                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                                        <Checkbox checked={isEUROCurrChecked} onChange={() => handleCheckboxChange('EURO')}> EURO</Checkbox>
                                    </FlexboxGrid.Item>
                                    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                                        <Checkbox checked={isGBPCurrChecked} onChange={() => handleCheckboxChange('GBP')}> GBP</Checkbox>
                                    </FlexboxGrid.Item>
                                </FlexboxGrid>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                                <h6>Cost Label Name</h6>
                                <FlexboxGrid justify="start">
                                    <Form>
                                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                                            <Form.ControlLabel>Min</Form.ControlLabel>
                                            <InputPicker data={data} style={{ width: 224 }} value={compedit.minlabelname || ''} onChange={value => handleInputChange("minlabelname", value, 0)} />
                                        </FlexboxGrid.Item>
                                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                                            <Form.ControlLabel>Average</Form.ControlLabel>
                                            <InputPicker data={data2} style={{ width: 224 }} value={compedit.avglabelname || ''} onChange={value => handleInputChange("avglabelname", value, 0)} />
                                        </FlexboxGrid.Item>
                                        <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                                            <Form.ControlLabel>Max</Form.ControlLabel>
                                            <InputPicker data={data3} style={{ width: 224 }} value={compedit.maxlabelname || ''} onChange={value => handleInputChange("maxlabelname", value, 0)} />
                                        </FlexboxGrid.Item>
                                    </Form>
                                </FlexboxGrid>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                        <Stack direction='row-reverse'>
                            <Button appearance='primary' color='cyan' onClick={handleStatusChange}>Save</Button>
                        </Stack>
                    </Panel>
                </div>
                <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}
export default Setting;